import { ReportsProvider } from "../hooks/reports"
import { ManagerQueryProvider } from "../services/manager";

export const ReportsHookQueryProvider = ({ children }) => {
    return (
        <ManagerQueryProvider>
            <ReportsProvider>{children}</ReportsProvider>
        </ManagerQueryProvider>
    )
}